var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Button, Step, StepContent, StepLabel, Stepper } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import { Field, Form, Formik } from 'formik';
import moment from 'moment-timezone';
import PubSub from 'pubsub-js';
import React, { useEffect, useState } from 'react';
import { checkSchedule } from '../../../api/Scheduler/Scheduler.API';
import { baseURL, config_baseURL, set_config_baseURL } from '../../../api/utils';
import { accounts } from '../../../frontend-config';
import { AccountSelector } from '../../commons/AccountSelector';
import { scheduleInitialValues } from '../../commons/assets/InitialValues';
import { EditableTextField } from '../../commons/EditableTextField';
import { ErrorText, SubName } from '../../commons/style/MUI.Styles';
import { convertTimeZone, getConvertedTimeZoneInUTC, getDateFromString, getRetainTimeZoneInUTC, getTimeDuration, toStringDate } from '../../commons/utils/DateFormatter';
import { rRuleDecode, ScheduleEvents, singleOccurrenceDecode } from '../../commons/utils/RRulesUtils';
import { schedulerFormValidationSchema } from '../../commons/validation/ScheduleValidation';
import { Title } from '../SchedulerMainView/SchedulerMainView.Styles';
import { CampaignSelection } from './CampaignSelection';
import { Schedule } from './Schedule';
import { ButtonWrapper, ConfigWrapper, FormWrapper, Wrapper } from './SchedulerConfigurator.Styles';
import { Sequence } from './Sequence';
import { validateMultipleFilter } from '../../../api';
import { FilterValidationResult } from '../../commons/FilterValidationResult';
export var SchedulerConfigurator = function (_a) {
    var onDiscardClick = _a.onDiscardClick, campaigns = _a.campaigns, studioFlows = _a.studioFlows, contactFilters = _a.contactFilters, phoneFilters = _a.phoneFilters, contactSorting = _a.contactSorting, contactLists = _a.contactLists, campaign = _a.campaign, readOnly = _a.readOnly, getOneCampaign = _a.getOneCampaign, updateSchedule = _a.updateSchedule, addSchedule = _a.addSchedule, setSelectedSched = _a.setSelectedSched, onDelete = _a.onDelete, onAlert = _a.onAlert, creating = _a.creating, selectedSched = _a.selectedSched, schedules = _a.schedules, scheduleEvents = _a.scheduleEvents, modType = _a.modType, dialerDefaults = _a.dialerDefaults, calendarTimeZone = _a.calendarTimeZone, schedulesBetweenTimes = _a.schedulesBetweenTimes, onAccountChange = _a.onAccountChange, getSchedulesBetweenTimes = _a.getSchedulesBetweenTimes, skipModal = _a.skipModal, onCampaignChange = _a.onCampaignChange;
    var step = useState(0)[0];
    var _b = useState(true), openStepOne = _b[0], setOpenStepOne = _b[1];
    var _c = useState(true), openStepTwo = _c[0], setOpenStepTwo = _c[1];
    var _d = useState(true), openStepThree = _d[0], setOpenStepThree = _d[1];
    var _e = useState(selectedSched), selectedSchedule = _e[0], setSelectedSchedule = _e[1];
    var _f = useState(''), occurrenceDate = _f[0], setOccurrenceDate = _f[1];
    var _g = useState(false), sequenceIsBeingEdited = _g[0], setSequenceIsBeingEdited = _g[1];
    var _h = useState(), configAccount = _h[0], setConfigAccount = _h[1];
    var _j = useState('none'), callingMode = _j[0], setCallingMode = _j[1];
    var _k = useState(false), notifyCampaignModeChangeEffects = _k[0], setNotifyCampaignModeChangeEffects = _k[1];
    var _l = useState(false), openValidationResult = _l[0], setOpenValidationResult = _l[1];
    var _m = useState(null), validationResult = _m[0], setValidationResult = _m[1];
    var handleModeSelection = function (mode, formValues) {
        var sequences = formValues === null || formValues === void 0 ? void 0 : formValues.sequences;
        if (mode === 'agentless' && (sequences === null || sequences === void 0 ? void 0 : sequences.length) > 0)
            setNotifyCampaignModeChangeEffects(true);
    };
    var handleCloseAlert = function () { return setNotifyCampaignModeChangeEffects(false); };
    var hasRunToday = selectedSchedule &&
        schedulesBetweenTimes.some(function (schedule) {
            return schedule.lastExecOccurrence ===
                new Date().toISOString().split('T')[0] &&
                selectedSchedule.id === schedule.schedule.id &&
                occurrenceDate &&
                selectedSchedule.Occurrence.Single &&
                new Date(occurrenceDate).toISOString().split('T')[0] ===
                    new Date().toISOString().split('T')[0];
        });
    var handleDiscard = function (resetForm) {
        setSequenceIsBeingEdited(false);
        setCallingMode('none');
        resetForm();
        onDiscardClick();
        setSelectedSched(null);
        PubSub.publish('schedule_discard', true);
    };
    var handleSequenceCallback = function (isBeingEdited) {
        setSequenceIsBeingEdited(isBeingEdited);
    };
    var handleSubmit = function (submitForm) {
        submitForm();
    };
    var checkScheduleName = function (formValues) {
        var lowerCheck = formValues.scheduleConfigName.toLowerCase();
        var scheduleCheck = schedules.filter(function (sched) {
            return sched.ScheduleName.toLowerCase() === lowerCheck;
        });
        return (scheduleCheck.length === 0 ||
            (scheduleCheck.length > 0 &&
                !creating &&
                formValues.scheduleConfigName === (selectedSchedule === null || selectedSchedule === void 0 ? void 0 : selectedSchedule.ScheduleName)));
    };
    useEffect(function () {
        setSelectedSchedule(selectedSched);
        if (selectedSched && selectedSched.prjacc) {
            setConfigAccount(accounts.find(function (a) { return a.url === selectedSched.prjacc.url; }));
            set_config_baseURL(selectedSched.prjacc.url);
            onAccountChange(selectedSched.prjacc.url);
        }
        else if (selectedSched && JSON.stringify(selectedSched) !== '{}') {
            setConfigAccount(accounts.find(function (a) { return a.url === baseURL(); }));
            onAccountChange(baseURL());
            set_config_baseURL(baseURL());
        }
        else {
            setConfigAccount(accounts.find(function (a) { return a.url === config_baseURL(); }));
            onAccountChange(config_baseURL());
        }
    }, [selectedSched]);
    var setFormValues = function (setValues) {
        var _a, _b, _c, _d, _e;
        var schedule = selectedSchedule;
        if (schedule && Object.keys(schedule).length > 0) {
            var decodedRule = {};
            if (schedule.Occurrence.Recurring) {
                var recurring = schedule.Occurrence.Recurring;
                decodedRule = rRuleDecode(recurring.RRule, schedule.Occurrence.Duration, moment.tz.guess(), calendarTimeZone, schedule.ScheduleTimeZone);
            }
            else if (schedule.Occurrence.Single) {
                decodedRule = singleOccurrenceDecode(schedule.Occurrence.Single.Date, schedule.Occurrence.Duration, moment.tz.guess(), calendarTimeZone);
            }
            getOneCampaign(schedule.CampaignId).then(function (data) {
                setCallingMode(data.value.data.campaign.BaseConfig.CallingMode);
            });
            var template = __assign(__assign({ scheduleConfigName: schedule.ScheduleName, timeZone: decodedRule.timeZone, doesEnd: modType === 'occurrence' ? true : decodedRule.doesEnd, startDate: decodedRule.startDate, startTime: decodedRule.startTime, endTime: decodedRule.endTime, endDate: decodedRule.endDate, recurrence: modType === 'occurrence'
                    ? { type: 'doesNotRepeat', value: 1, misc: '' }
                    : decodedRule.recurrence, campaign: schedule.CampaignId, scheduleLoops: schedule.Loops }, (callingMode === 'agentless' && ((_a = schedule.PacingOverride) === null || _a === void 0 ? void 0 : _a.ConcurrentCalls) &&
                ((_b = schedule.PacingOverride) === null || _b === void 0 ? void 0 : _b.ConcurrentCalls) != null &&
                !Number.isNaN((_c = schedule.PacingOverride) === null || _c === void 0 ? void 0 : _c.ConcurrentCalls) && {
                concurrentCallsOverride: (_d = schedule.PacingOverride) === null || _d === void 0 ? void 0 : _d.ConcurrentCalls
            })), { concurrentCallsOverride: (_e = schedule.PacingOverride) === null || _e === void 0 ? void 0 : _e.ConcurrentCalls, sequences: schedule.Sequences.map(function (seq) {
                    var _a, _b, _c, _d, _e;
                    return __assign({ sequenceName: seq.SequenceName, basicConfig: {
                            livePartyHandler: seq.BasicConfig.ConnectBehavior,
                            livePartyContactFlow: seq.BasicConfig.DefaultContactFlow,
                            answeringMachineHandler: seq.BasicConfig.MachineDetectedBehavior,
                            answeringMachineContactFlow: seq.BasicConfig.MachineDetectedContactFlow,
                            phones: seq.BasicConfig.Phones
                        }, filteringAndSorting: {
                            contactFilters: seq.FilterSort.ClFilters.reduce(function (accVal, clf) {
                                var filterData = contactFilters === null || contactFilters === void 0 ? void 0 : contactFilters.find(function (cf) { return cf.id === clf.FilterID; });
                                if (filterData) {
                                    accVal.push({
                                        value: filterData.id,
                                        label: filterData.filterName
                                    });
                                }
                                return accVal;
                            }, []) || [],
                            phoneFilters: ((_b = (_a = seq === null || seq === void 0 ? void 0 : seq.FilterSort) === null || _a === void 0 ? void 0 : _a.PndFilters) === null || _b === void 0 ? void 0 : _b.reduce(function (accVal, pnf) {
                                var filterData = phoneFilters === null || phoneFilters === void 0 ? void 0 : phoneFilters.find(function (cf) { return cf.id === pnf.FilterID; });
                                if (filterData) {
                                    accVal.push({
                                        value: filterData.id,
                                        label: filterData.filterName
                                    });
                                }
                                return accVal;
                            }, [])) || [],
                            contactSorting: ((_d = (_c = seq === null || seq === void 0 ? void 0 : seq.FilterSort) === null || _c === void 0 ? void 0 : _c.ClSorts) === null || _d === void 0 ? void 0 : _d.reduce(function (accVal, cls) {
                                var filterData = contactSorting === null || contactSorting === void 0 ? void 0 : contactSorting.find(function (cf) { return cf.id === cls.OrderByID; });
                                if (filterData) {
                                    accVal.push({
                                        value: filterData.id,
                                        label: filterData.filterName
                                    });
                                }
                                return accVal;
                            }, [])) || []
                        } }, (seq.Pacing && {
                        pacing: __assign({ clearPacing: ((_e = seq.Pacing) === null || _e === void 0 ? void 0 : _e.ClearStats) ? 'yes' : 'no' }, (seq.Pacing.PacingOverride && {
                            initialCpaMode: seq.Pacing.PacingOverride.InitialCPAMode,
                            initialCpa: seq.Pacing.PacingOverride.InitialCPA,
                            initialDuration: seq.Pacing.PacingOverride.InitialDuration,
                            abaIncrement: seq.Pacing.PacingOverride.AbaIncrement,
                            cpaModifier: seq.Pacing.PacingOverride.CpaModifier,
                            abaCalculation: seq.Pacing.PacingOverride.AbaCalculation,
                            abaTargetRate: seq.Pacing.PacingOverride.AbaTargetRate
                        }))
                    }));
                }), isHoliday: false, isEnabled: false });
            if (schedule.ScheduleTimeZone) {
                var startDateTime = convertTimeZone(new Date(template.startDate + " " + template.startTime), calendarTimeZone, schedule.ScheduleTimeZone);
                var occurrenceDate_1 = getConvertedTimeZoneInUTC(new Date(startDateTime), schedule.ScheduleTimeZone).split('T')[0];
                setOccurrenceDate(occurrenceDate_1);
            }
            else {
                setOccurrenceDate(template.startDate);
            }
            // getOneCampaign(template.campaign);
            setValues(template);
        }
    };
    var onSend = function (data, resetForm) {
        var _a, _b, _c, _d, _e;
        var currentSchedule = selectedSchedule;
        var schedRule = {
            timeZone: data.timeZone,
            startDate: data.startDate,
            startTime: data.startTime,
            endDate: data.recurrence.type === 'doesNotRepeat'
                ? data.startDate
                : data.endDate,
            endTime: data.endTime,
            recurrence: data.recurrence,
            eventName: data.scheduleConfigName,
            isEnabled: data.isEnabled,
            hasOccurrences: data.recurrence.type !== 'doesNotRepeat' ? true : false,
            doesEnd: data.doesEnd,
            isHoliday: data.isHoliday,
            campaignId: data.campaign,
            eventID: ''
        };
        var rule = new ScheduleEvents().conf(schedRule, dialerDefaults.ScheduleTimezone);
        var startDateTime = new Date(getRetainTimeZoneInUTC(getDateFromString(toStringDate(schedRule.startDate), schedRule.startTime), schedRule.timeZone, dialerDefaults.ScheduleTimezone));
        var endDateTime = new Date(getRetainTimeZoneInUTC(getDateFromString(toStringDate(schedRule.endDate), schedRule.endTime), schedRule.timeZone, dialerDefaults.ScheduleTimezone));
        var singleStartDateTime = new Date(getConvertedTimeZoneInUTC(getDateFromString(toStringDate(schedRule.startDate), schedRule.startTime), schedRule.timeZone));
        var singleEndDateTime = new Date(getConvertedTimeZoneInUTC(getDateFromString(toStringDate(schedRule.endDate), schedRule.endTime), schedRule.timeZone));
        var occurrence = {
            Single: {
                Date: singleStartDateTime.toISOString(),
                Parent: modType === 'occurrence' ? selectedSchedule === null || selectedSchedule === void 0 ? void 0 : selectedSchedule.id : ''
            },
            Duration: Math.floor(getTimeDuration(singleStartDateTime, singleEndDateTime) /
                60000) || 0
        };
        if (schedRule.hasOccurrences && modType === 'series') {
            occurrence = {
                Recurring: {
                    DisabledDates: ((_b = (_a = currentSchedule === null || currentSchedule === void 0 ? void 0 : currentSchedule.Occurrence) === null || _a === void 0 ? void 0 : _a.Recurring) === null || _b === void 0 ? void 0 : _b.DisabledDates) || [],
                    Exclusions: ((_d = (_c = currentSchedule === null || currentSchedule === void 0 ? void 0 : currentSchedule.Occurrence) === null || _c === void 0 ? void 0 : _c.Recurring) === null || _d === void 0 ? void 0 : _d.Exclusions) || [],
                    RRule: ((_e = rule === null || rule === void 0 ? void 0 : rule.rRule) === null || _e === void 0 ? void 0 : _e.toString()) || ''
                },
                Duration: Math.floor(rule.duration / 60000) || 0
            };
        }
        var schedule = __assign(__assign({ ScheduleName: data.scheduleConfigName, Occurrence: occurrence, CampaignId: data.campaign, 
            // CallingMode: data.campaignMode,
            // ...(data.campaignMode === 'agentless' &&
            //   data.concurrentCallsOverride &&
            //   data.concurrentCallsOverride !== 0 &&
            //   data.concurrentCallsOverride != null &&
            //   data.concurrentCallsOverride !== NaN && {
            //     PacingOverride: {
            //       ConcurrentCalls: data.concurrentCallsOverride,
            //     },
            //   }),
            Loops: data.scheduleLoops }, (callingMode === 'agentless' &&
            data.concurrentCallsOverride &&
            data.concurrentCallsOverride !== 0 &&
            data.concurrentCallsOverride !== null &&
            !Number.isNaN(data.concurrentCallsOverride) && {
            PacingOverride: {
                ConcurrentCalls: data.concurrentCallsOverride
            }
        })), { Sequences: data.sequences.map(function (seq) { return (__assign({ SequenceName: seq.sequenceName, BasicConfig: {
                    AmDetection: true,
                    MachineDetectedBehavior: seq.basicConfig.answeringMachineHandler,
                    ConnectBehavior: seq.basicConfig.livePartyHandler,
                    MachineDetectedContactFlow: seq.basicConfig.answeringMachineContactFlow === 'none'
                        ? ''
                        : seq.basicConfig.answeringMachineContactFlow,
                    DefaultContactFlow: seq.basicConfig.livePartyContactFlow === 'none'
                        ? ''
                        : seq.basicConfig.livePartyContactFlow,
                    Phones: seq.basicConfig.phones
                }, FilterSort: {
                    ClFilters: seq.filteringAndSorting.contactFilters.map(function (cl) { return ({
                        FilterID: cl.value
                    }); }),
                    PndFilters: seq.filteringAndSorting.phoneFilters.map(function (pf) { return ({
                        FilterID: pf.value
                    }); }),
                    ClSorts: seq.filteringAndSorting.contactSorting.map(function (cs) { return ({
                        OrderByID: cs.value,
                        OrderByType: 'DESC'
                    }); })
                } }, (callingMode === 'power' &&
                seq.pacing && {
                Pacing: __assign(__assign({ ClearStats: seq.pacing.clearPacing === 'yes' }, (seq.pacing.clearPacing === 'yes' && {
                    PacingOverride: {
                        InitialCPAMode: seq.pacing.initialCpaMode,
                        InitialCPA: seq.pacing.initialCpa,
                        InitialDuration: seq.pacing.initialDuration,
                        AbaIncrement: seq.pacing.abaIncrement,
                        CpaModifier: seq.pacing.cpaModifier,
                        AbaCalculation: seq.pacing.abaCalculation,
                        AbaTargetRate: seq.pacing.abaTargetRate
                    }
                })), (seq.pacing.clearPacing === 'no' && {
                    PacingOverride: {
                        InitialCPAMode: campaign.Pacing.InitialCPAMode,
                        InitialCPA: campaign.Pacing.InitialCPA,
                        InitialDuration: campaign.Pacing.InitialDuration,
                        AbaIncrement: campaign.Pacing.AbaIncrement,
                        CpaModifier: campaign.Pacing.CpaModifier,
                        AbaCalculation: campaign.Pacing.AbaCalculation,
                        AbaTargetRate: campaign.Pacing.AbaTargetRate
                    }
                }))
            }))); }) });
        if (!creating) {
            updateSchedule(schedule, selectedSched.id, startDateTime.toISOString(), function () {
                handleDiscard(resetForm);
            }, selectedSchedule);
        }
        else {
            addSchedule(schedule, function () {
                handleDiscard(resetForm);
            });
        }
    };
    var validateFilters = function (payload) {
        setOpenValidationResult(true);
        validateMultipleFilter(payload).then(function (data) {
            console.log('validationSuccess', data.data);
            setValidationResult({ status: 'success', data: data.data.results });
        })["catch"](function (error) {
            console.log('validationError', error.response.data);
            setValidationResult({ status: 'error', data: error.response.data });
        });
    };
    return (React.createElement(Wrapper, null,
        React.createElement(FormWrapper, null,
            React.createElement(Formik, { initialValues: scheduleInitialValues(calendarTimeZone), validationSchema: schedulerFormValidationSchema(dialerDefaults, callingMode), onSubmit: function (values, _a) {
                    var setSubmitting = _a.setSubmitting, resetForm = _a.resetForm;
                    if (checkScheduleName(values)) {
                        onSend(values, resetForm);
                    }
                    else {
                        onAlert('This Schedule Name is already in use please use a new one', 'warning');
                    }
                    setSubmitting(false);
                } }, function (_a) {
                var submitForm = _a.submitForm, isSubmitting = _a.isSubmitting, resetForm = _a.resetForm, values = _a.values, setFieldValue = _a.setFieldValue, touched = _a.touched, errors = _a.errors, setValues = _a.setValues, registerField = _a.registerField;
                return (React.createElement(React.Fragment, null,
                    React.createElement(Form, null,
                        useEffect(function () {
                            setTimeout(function () {
                                setFormValues(setValues);
                            }, 400);
                        }, [selectedSchedule, calendarTimeZone]),
                        useEffect(function () {
                            setFieldValue('timeZone', calendarTimeZone);
                        }, [calendarTimeZone]),
                        React.createElement(Title, { variant: 'h5', gutterBottom: true },
                            React.createElement(Field, { name: 'scheduleConfigName', label: 'Schedule', component: EditableTextField }),
                            React.createElement(SubName, { variant: 'body2' }, selectedSchedule && selectedSchedule.id)),
                        React.createElement(ErrorText, null, hasRunToday
                            ? 'Schedules that have already run today are uneditable!'
                            : ''),
                        React.createElement(Divider, null),
                        React.createElement(ConfigWrapper, null,
                            React.createElement(AccountSelector, { initialValue: configAccount, onValueChange: function (account) {
                                    if (account && account !== 'All') {
                                        setConfigAccount(account);
                                        onAccountChange(account.url);
                                        set_config_baseURL(account.url);
                                    }
                                }, fullWidth: true, noAll: true, disabled: !creating })),
                        React.createElement(Divider, null),
                        React.createElement(Stepper, { activeStep: step, orientation: 'vertical' },
                            React.createElement(Step, { active: openStepOne },
                                React.createElement(StepLabel, { onClick: function () {
                                        // setStep(0)
                                        setOpenStepOne(!openStepOne);
                                    } }, "Schedule"),
                                React.createElement(StepContent, null,
                                    React.createElement(Schedule, { values: values, setFieldValue: setFieldValue, touched: touched, errors: errors }))),
                            React.createElement(Step, { active: openStepTwo },
                                React.createElement(StepLabel, { onClick: function () {
                                        // setStep(1)
                                        setOpenStepTwo(!openStepTwo);
                                    } }, "Campaign Selection"),
                                React.createElement(StepContent, null,
                                    React.createElement(CampaignSelection, { campaign: campaign, campaigns: campaigns, errors: errors, getOneCampaign: getOneCampaign, values: values, setFieldValue: setFieldValue, registerField: registerField, setCallingMode: setCallingMode, callingMode: callingMode }))),
                            React.createElement(Step, { active: openStepThree },
                                React.createElement(StepLabel, { onClick: function () {
                                        // setStep(2)
                                        setOpenStepThree(!openStepThree);
                                    } }, "Sequences"),
                                React.createElement(StepContent, null,
                                    React.createElement(Sequence, { values: values, dialerDefaults: dialerDefaults, setFieldValue: setFieldValue, touched: touched, errors: errors, campaigns: campaigns, selectedSchedule: selectedSchedule, studioFlows: studioFlows, contactFilters: contactFilters, phoneFilters: phoneFilters, contactLists: contactLists, contactSorting: contactSorting, campaign: campaign, sequenceIsBeingEdited: sequenceIsBeingEdited, handleSequenceCallback: handleSequenceCallback, isBeingEdited: sequenceIsBeingEdited, skipModal: skipModal, onCampaignChange: onCampaignChange, callingMode: callingMode, onMultipleValidation: function (data) {
                                            validateFilters(data);
                                        } }))),
                            React.createElement(Step, { expanded: true },
                                React.createElement(StepContent, null,
                                    React.createElement(ButtonWrapper, null,
                                        React.createElement(Button, { variant: 'contained', color: 'primary', disabled: isSubmitting || sequenceIsBeingEdited || readOnly, onClick: function () {
                                                if (!hasRunToday || creating) {
                                                    handleSubmit(submitForm);
                                                }
                                            } }, creating === true ? 'Create' : 'Update'),
                                        !creating && (React.createElement(Button, { variant: 'contained', color: 'primary', disabled: isSubmitting || sequenceIsBeingEdited || readOnly, onClick: function () {
                                                var convertedNow = new Date(convertTimeZone(new Date(), moment.tz.guess(), dialerDefaults.ScheduleTimezone));
                                                var dateOccurrence = new Date(occurrenceDate);
                                                if (modType === 'occurrence' &&
                                                    dateOccurrence > convertedNow &&
                                                    dateOccurrence.toDateString() !==
                                                        convertedNow.toDateString()) {
                                                    onDelete(selectedSchedule.id, occurrenceDate, function () {
                                                        handleDiscard(resetForm);
                                                    });
                                                }
                                                else {
                                                    checkSchedule(selectedSchedule.id)
                                                        .then(function (data) {
                                                        onDelete(selectedSchedule.id, occurrenceDate, function () {
                                                            handleDiscard(resetForm);
                                                        });
                                                    })["catch"](function (err) {
                                                        onAlert('Cannot delete schedule while running!', 'warning');
                                                    });
                                                }
                                            } }, "Delete")),
                                        React.createElement(Button, { variant: 'contained', color: 'primary', onClick: function () { return handleDiscard(resetForm); } }, readOnly ? 'Close' : 'Discard'))))))));
            })),
        React.createElement(FilterValidationResult, { title: 'Validate Filter', open: openValidationResult, onClose: function () {
                setOpenValidationResult(false);
                setValidationResult(null);
            }, data: validationResult })));
};
SchedulerConfigurator.defaultProps = {
    // bla: 'test',
    title: 'Create Schedule'
};
//# sourceMappingURL=SchedulerConfigurator.js.map